export class SessionMap {
    id: number;
    application: string;
    applicationId: number;
    // meta;
    showOpen;

    constructor(data){
        this.id = data.id;
        this.application = data.application;
        this.applicationId = data.app_session_id;

        let meta = JSON.parse(data.meta);
        this.showOpen = (meta.show_lms_open || meta.show_open) ? (meta.show_lms_open) ? meta.show_lms_open : meta.show_open : false;
    }
}
